import {
  Component,
  OnInit,
  Input,
  Injector,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-profile-bar",
  templateUrl: "./profile-bar.component.html",
  styleUrls: ["./profile-bar.component.scss"],
})
export class ProfileBarComponent implements OnInit {
  title: string;
  subTitle: string;
  @Input() routeParam: string;
  @Input() showAETitle: string;
  @Input() hideSubTable: string;
  currDate: Date;
  @Output() dateSelection = new EventEmitter();
  @Output() setBackTable = new EventEmitter();
  @Input() showETF: any = false;
  @Input() selectedRows: any;
  selectedFundIds: any = [];
  exportSelectedFundId: any;
  selectedFundCodes: any = [];
  @Input() showFundTitle: any;
  fundId: any;
  @Input() bbg: any;
  @Input() opsFundType: any;
  currentDate: Date;

  constructor(
    private router: Router,
    public injector: Injector,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.currentDate = new Date();
    this.route.params.subscribe((params) => {
      this.fundId = params["id"];
    });
    this.changeTitle();
  }
  ngOnChanges(SimpleChanges: SimpleChanges) {
    for (let [key, value] of Object.entries(SimpleChanges)) {
      if (key === "routeParam") {
        this.changeTitle();
      }
    }
  }
  changeTitle() {
    this.title = this.routeParam.includes("nav1")
      ? "NAV1 Reconciliation"
      : this.routeParam.includes("nav2")
      ? "NAV2 Reconciliation"
      : this.routeParam.includes("D & C")
      ? "D & C CONFIG"
      : this.routeParam.includes("holidayCalendarMaster")
      ? "HOLIDAY CALENDAR"
      : this.routeParam.includes("datamarketplace")
      ? "Data MarketPlace"
      : this.routeParam.includes("d&c")
      ? "ORDER SUMMARY"
      : this.routeParam.includes("accountConfig")
      ? "ACCOUNT POSTING"
      : this.routeParam.includes("accountingEntries")
      ? "ACCOUNTING ENTRIES"
      : this.routeParam.includes("caConfig")
      ? "CA CONFIG"
      : this.routeParam.includes("tdte")
      ? "TD/TE"
      : this.routeParam.includes("tdThreshold")
      ? "TD Threshold"
      : this.routeParam.includes("job-config")
      ? "JOBS"
      : this.routeParam.includes("newsletter_config")
      ? "NEWSLETTER CONFIG"
      : this.routeParam.includes("profile_config_mmf")
      ? "Liquidity Profile Threshold Config(MMF Funds)"
      : this.routeParam.includes("cost_config")
      ? "Liquidation Cost Threshold Config"
      : this.routeParam.includes("profile_config_nonmmf")
      ? "Liquidity Profile Threshold Config(Non-MMF Funds)"
      : this.routeParam.includes("liquidation_cost")
      ? "Liquidation Cost"
      : this.routeParam.includes("liquidity_profile")
      ? "Liquidity Profile"
      : this.routeParam.includes("SECURITY_TYPE")
      ? "SECURITY TYPE"
      : this.routeParam.includes("FA_FUND_AND_ACCOUNT_SCREEN")
      ? "FA FUND & ACCOUNT"
      : this.routeParam.includes("BROKER_SSI")
      ? "BROKER SSI"
      : this.routeParam.includes("TRADE_PROCESSING_SYSTEM")
      ? "TRADE PROCESSING SYSTEM"
      : this.routeParam.includes("TRADE_BLOTTER")
      ? "Trade Blotter"
      : this.routeParam.includes("STAGING_TRANSMISSION")
      ? "Staging-Transmission"
      : this.routeParam.includes("STATIC_DATA_APPROVAL_REQUEST")
      ? "Static Data Approval Request"
      : this.routeParam.includes("EXCEPTION_MONITOR")
      ? "Exception Monitor"
      : this.routeParam.includes("format_code_def")
      ? "FORMAT CODE DEF"
      : this.routeParam.includes("format_code_field_def")
      ? "FORMAT CODE FIELD DEF"
      : this.routeParam.includes("export_file")
      ? "EXPORT FILE"
      : this.routeParam.includes("instruction_def")
      ? "INSTRUCTION DEF"
      : "Premium Discount & Cash Component";
    if (
      this.title == "TD/TE" ||
      this.title == "D & C CONFIG" ||
      this.title == "HOLIDAY CALENDAR" ||
      this.title == "Data MarketPlace" ||
      this.title == "ORDER SUMMARY" ||
      this.title == "ACCOUNT POSTING" ||
      this.title == "ACCOUNTING ENTRIES" ||
      this.title == "CA CONFIG" ||
      this.title == "TD Threshold" ||
      this.title == "JOBS" ||
      this.title == "NEWSLETTER CONFIG" ||
      this.title.includes("Liquidity Profile") ||
      this.title == "Liquidation Cost Threshold Config" ||
      this.title == "Liquidation Cost" ||
      this.title == "TPS FILE MAPPING" ||
      this.title == "SECURITY TYPE" ||
      this.title == "FA FUND & ACCOUNT" ||
      this.title == "BROKER SSI" ||
      this.title == "TRADE PROCESSING SYSTEM" ||
      this.title == "Trade Blotter" ||
      this.title == "Staging-Transmission" ||
      this.title == "Static Data Approval Request" ||
	    this.title == "Exception Monitor" ||
      this.title == "FORMAT CODE DEF" ||
      this.title == "FORMAT CODE FIELD DEF" ||
      this.title == "INSTRUCTION DEF"
    )
      this.subTitle = null;
    else
      this.subTitle =
        this.routeParam.includes("signedoff") && this.routeParam.includes("t0")
          ? "Signed Off vs Not Signed Off Funds : T0"
          : this.routeParam.includes("signedoff") &&
            this.routeParam.includes("t1")
          ? "Signed Off vs Not Signed Off Funds : T1"
          : this.routeParam.includes("reconcile") &&
            this.routeParam.includes("t1")
          ? "Reconciled vs Not Reconciled : T1"
          : this.routeParam.includes("reconcile") &&
            this.routeParam.includes("t0")
          ? "Reconciled vs Not Reconciled : T0"
          : this.routeParam.includes("exception") &&
            this.routeParam.includes("t0")
          ? "Exceptions vs No Exceptions : T0"
          : this.routeParam.includes("exception") &&
            this.routeParam.includes("t1")
          ? "Exceptions vs No Exceptions : T1"
          : "Met SLA vs Unmet SLA";

    if (
      this.title == "TD/TE" ||
      this.title == "TD Threshold" ||
      this.title == "JOBS" ||
      this.title.includes("Liquidity Profile") ||
      this.title == "Liquidation Cost Threshold Config" ||
      this.title == "Liquidation Cost"
    ) {
      this.currDate = new Date(localStorage.getItem("asOfDate"));
    } else {
      this.currDate = new Date(localStorage.getItem("opsAsOfDate"));
    }

    if (this.fundId) {
      this.selectedFundIds.push(this.fundId);
    } else {
      this.selectedRows = JSON.parse(localStorage.getItem("selectedRows"));
    }

    if (this.selectedRows?.length > 0) {
      this.fundCodesToShow();
    }
  }

  fundCodesToShow() {
    this.selectedRows?.forEach((d: any) => {
      this.selectedFundIds?.push(d.fund_id);
      this.exportSelectedFundId?.push(d.fund_id.toString());
      this.selectedFundCodes?.push(d.tradar_code);
      this.selectedFundCodes = this.selectedFundCodes.filter(
        (item, i, ar) => ar.indexOf(item) === i
      );
      this.selectedFundIds = [
        ...this.selectedFundIds.filter((item, i, ar) => ar.indexOf(item) === i),
      ];
    });
  }

  onClickBack(param: any) {
    if (this.hideSubTable) {
      this.setBackTable.emit(false);
    } else if (param === "pdcc" || this.showFundTitle) {
      this.location.back();
    } else if (this.showAETitle) {
      let routerPath = localStorage.getItem("d%cRoutePath");
      localStorage.removeItem("selectedRows");
      this.router.navigate([routerPath]);
      // this.location.back();
    } else if (param == "newsletter_config") {
      localStorage.setItem("reportAction", "back");
      this.router.navigate(["newsletterreport"]);
    } else if (param == "cost_config") {
      this.router.navigate(["liquidationcost"]);
    } else if (
      param == "profile_config_nonmmf" ||
      param == "profile_config_mmf"
    ) {
      this.router.navigate(["liquidityprofile"]);
    } else {
      localStorage.removeItem("filtersObj");
      this.router.navigate(["dashboard"]);
    }
  }

  onChangeDate(date: any) {
    localStorage.setItem("opsAsOfDate", date);
    localStorage.setItem("asOfDate", date);
    this.dateSelection.emit(date);
  }
}
